export default "__VITE_ASSET__124e2b88__"